module.exports = __webpack_public_path__ + "static/media/apparel4.5541a734.jpg";